// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performancePlayerPageRow{
    display: flex;
    flex-direction: row;
}

  .performancePlayerPage{
    display: flex;
    flex-direction: column;
    gap:24px;
    padding:32px;
    width: calc(100% - 100px);
    background-color: #ffffff;
    margin-left: 100px;
  }
  
  
  .performancePlayerPageColorPurple{
    color:#6F60C8;
  }
  
  .performancePlayerPageColorOrange{
    color:#E97247;
  }
  
  
  .performancePlayerPageColorGreen{
    color:#4CAF50;
  }
  
  .performancePlayerPageFontSize40{
    font-size: 40px;
  }
  
  .performancePlayerPageFontSize20{
    font-size: 20px;
  }
  .performancePlayerPageFontSize36{
    font-size: 36px;
  }
  .performancePlayerPageFontSize24{
    font-size: 24px;
  }
  .performancePlayerPagePerformanceColumn{
    display: flex;
    flex-direction: column;
    gap:20px;
    padding:40px 100px 60px 100px;
  }
  
  .performancePlayerPagePerformanceColumnItem{
    display: flex;
    flex-direction: column;
    gap:20px;
  }
  
  .performancePlayerPagePerformanceColumnItemLabel{
    font-size: 20px;
  }
  
  .performancePlayerPageUser{
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
  
  .performancePlayerPageUserInfo{
    font-size: 28px;
    padding: 20px 0;
  }
  
  .performancePlayerPageUserIcon{
    width: 25px;
    height: auto;
  }
  
  .performancePlayerPageUserIconChecked{
    width: 35px;
    height: auto;
  }
  
  .performancePlayerPageIdAcordo{
    display: flex;
    flex-direction: column;
    gap:20px;
    max-width: 80%;
  }
  .performancePlayerPageContentChoose{
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
    padding:20px;
    cursor:pointer;
  }
  
  .performancePlayerPageContentSelect{
    display: flex;
    flex-direction: column;
    gap:10px;
    margin-left: 10%;
  }
  
  .performancePlayerPageItemContent{
    border-left: 1px solid #6F60C8;
    padding:10px 40px;
    margin-bottom: 20px;
  }
  
  .performancePlayerPageContentSelect p {
    padding: 5px;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/pages/PerformancePage/PerformancePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;EACpB;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd","sourcesContent":[".performancePlayerPageRow{\n    display: flex;\n    flex-direction: row;\n}\n\n  .performancePlayerPage{\n    display: flex;\n    flex-direction: column;\n    gap:24px;\n    padding:32px;\n    width: calc(100% - 100px);\n    background-color: #ffffff;\n    margin-left: 100px;\n  }\n  \n  \n  .performancePlayerPageColorPurple{\n    color:#6F60C8;\n  }\n  \n  .performancePlayerPageColorOrange{\n    color:#E97247;\n  }\n  \n  \n  .performancePlayerPageColorGreen{\n    color:#4CAF50;\n  }\n  \n  .performancePlayerPageFontSize40{\n    font-size: 40px;\n  }\n  \n  .performancePlayerPageFontSize20{\n    font-size: 20px;\n  }\n  .performancePlayerPageFontSize36{\n    font-size: 36px;\n  }\n  .performancePlayerPageFontSize24{\n    font-size: 24px;\n  }\n  .performancePlayerPagePerformanceColumn{\n    display: flex;\n    flex-direction: column;\n    gap:20px;\n    padding:40px 100px 60px 100px;\n  }\n  \n  .performancePlayerPagePerformanceColumnItem{\n    display: flex;\n    flex-direction: column;\n    gap:20px;\n  }\n  \n  .performancePlayerPagePerformanceColumnItemLabel{\n    font-size: 20px;\n  }\n  \n  .performancePlayerPageUser{\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    align-items: center;\n  }\n  \n  .performancePlayerPageUserInfo{\n    font-size: 28px;\n    padding: 20px 0;\n  }\n  \n  .performancePlayerPageUserIcon{\n    width: 25px;\n    height: auto;\n  }\n  \n  .performancePlayerPageUserIconChecked{\n    width: 35px;\n    height: auto;\n  }\n  \n  .performancePlayerPageIdAcordo{\n    display: flex;\n    flex-direction: column;\n    gap:20px;\n    max-width: 80%;\n  }\n  .performancePlayerPageContentChoose{\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    align-items: center;\n    padding:20px;\n    cursor:pointer;\n  }\n  \n  .performancePlayerPageContentSelect{\n    display: flex;\n    flex-direction: column;\n    gap:10px;\n    margin-left: 10%;\n  }\n  \n  .performancePlayerPageItemContent{\n    border-left: 1px solid #6F60C8;\n    padding:10px 40px;\n    margin-bottom: 20px;\n  }\n  \n  .performancePlayerPageContentSelect p {\n    padding: 5px;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
